import API from "../../helpers/network/http";
import {Song} from "../../utils/types";
import axios from "axios";
import {getLS} from "../../helpers/ls"; // Import your manually defined types

interface GraphQLRequestPayload {
    query: string;
    variables?: { [key: string]: any };
}

export const GET_SONGS_QUERY = `
  query GetSongs($page: Int, $limit: Int, $genre: String, $tag: String) {
    songs(page: $page, limit: $limit, genre: $genre, tag: $tag) {
      id
      title
      artist
      genre
      listens
      is_rehearsed
      stems {
        part_type
        url
        waveform
      }
    }
  }
`;

export const GET_SONG_BY_ID_QUERY = `
  query GetSongById($id: ID!) {
    song(id: $id) {
      id
      title
      artist
      genre
      listens
      isRehearsed
      isPremiumContent
      stems {
        part_type
        url
        waveform
      }
    }
  }
`;

// Define the base Axios instance
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:9000/graphql',
    headers: {
        Authorization: `Bearer ${getLS('access_token')}`,
    },
});

// Fetch songs function
export const fetchGraphQL = async ({ query, variables }: GraphQLRequestPayload) => {
    try {
        const response = await axiosInstance.post('', {
            query,
            variables,
        });
        console.log(response)
        return response.data.data; // Return only the data part of the GraphQL response
    } catch (error: any) {
        throw new Error(error.response?.data?.errors?.[0]?.message || 'GraphQL request failed');
    }
};

export default class SongService {
    // Create a method to fetch songs
    static async fetchSongs(query: any): Promise<Song[] | any> {
        // Call the login endpoint from the API
        const {data} = await API.get(`/songs`, {
            params: query // Add query params
        });
        // Return the response
        return data;

    };

    static async fetchSong(id: string): Promise<Song[] | any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/songs/${id}`);
        // Return the response
        return data;

    };

    static async searchSongs(query: any): Promise<Song[] | any> {
            // Call the login endpoint from the API
            const {data} = await API.get(`/songs/search/omni`, {
                params: {query: query.query}, // Add query params
            });
            // Return the response
            return data
    }


};


// const songs = [
//     {
//         id: "1",
//         title: "Song 1",
//         artist: "Artist 1",
//         genre: "Genre 1",
//         votes: 10,
//         listens: 20,
//         key: "Key 1",
//         tempo: "Tempo 1",
//         duration: "Duration 1",
//         time_signature: "Time Signature 1",
//         song_art: "Song Art 1",
//         album: "Album 1",
//         writer: "Writer 1",
//         file_url: "File URL 1",
//         stems: [
//             {
//                 id: "1",
//                 song_id: "1",
//                 part_type: "Part Type 1",
//                 cid: "CID 1",
//                 url: "URL 1",
//                 waveform: "Waveform 1",
//                 preview_url: "Preview URL 1",
//                 preview_waveform: "Preview Waveform 1",
//                 created_at: "Created At 1",
//                 updated_at: "Updated At 1"
//             }
//         ],
//         lyrics: "Lyrics 1",
//         solfa_notation: "Solfa Notation 1",
//         is_rehearsed: true,
//         is_premiumContent: true
//     }
// ];